<!-- <template>
  <b-row>
    <template v-for="newsItem in news">
      <b-col cols="12" lg="4" :key="newsItem.id">
        <b-card
          no-body
          :img-src="newsItem.image_url"
          :img-alt="newsItem.title"
          :img-width="'100%'"
          img-top
          class="mb-2"
        >
          <b-card-body>   
            <b-card-text style="height:5vh">
              <h4 class="c-h4" >{{ newsItem.title | truncate(35)}}</h4>
            </b-card-text>
            <b-card-text>
              <div class="d-flex justify-content-between">
                <small class="text-muted">
                  <span>by </span>
                  <strong>{{ newsItem.author }}</strong>
                </small>
                <small class="text-muted">{{
                  $moment(newsItem.published_at).format('DD-MMM-YYYY')
                }}</small>
              </div>
            </b-card-text>
            <b-card-text
              class="c-text"
              style="height: 16vh;"
              :inner-html.prop="newsItem.content | truncate(150)"
            />
            <hr />
            <div class="d-flex justify-content-end">
              <router-link
                :to="{ name: 'news-detail', params: { slug: newsItem.slug } }"
                class="text-link"
              >
                Read More
              </router-link>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </template>
  </b-row>
</template>

<script>
import { BCardBody, BAspect, BCard, BRow, BCol, BCardText, BButton } from 'bootstrap-vue'

export default {
  props: {
    news: {
      type: Array,
    },
  },

  components: {
    BAspect,
    BCard,
    BRow,
    BCol,
    BCardText,
    BButton,
    BCardBody
  },

  filters: {
    truncate: function(value, length, start = 0) {
      if (!value) return ''
      value = value.toString()
      if (value.length > length) {
        if (start > 0) {
          return value.substring(start, length + start) + '...'
        } else {
          return value.substring(start, length) + '...'
        }
      } else {
        return value
      }
    },
  },
}
</script>

<style scoped>
.card-img, .card-img-top, .card-img-bottom {
  height: calc(32.70vh/1.7);
}
</style> -->
<template>
  <b-row>
    <template v-for="newsItem in news">
      <b-col cols="12" md="4" class="d-flex flex-column" :key="newsItem.id">
        <b-card
          no-body
          class="d-flex flex-column flex-grow-1 mb-2"
        >
          <img
            :src="newsItem.image_url"
            :alt="newsItem.title"
            class="card-img-top"
          />
          <b-card-body class="d-flex flex-column flex-grow-1">
            <b-card-text>
              <h4 class="c-h4" >{{ newsItem.title | truncate(40)}}</h4>
            </b-card-text>
            <b-card-text
              class="flex-grow-1 c-text"
              style="text-align: justify"
              :inner-html.prop="newsItem.content | truncate(100)"
            />
            <hr class="w-100" />
            <div class="d-flex justify-content-between">
              <div>
                <span>Published At : {{$moment(newsItem.published_at).format('DD/MM/YYYY')}}</span>
              </div>
              <router-link
                :to="{ name: 'news-detail', params: { slug: newsItem.slug } }"
                class="text-link btn btn-sm btn-outline-primary"
              >
                Read More
              </router-link>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </template>
  </b-row>
</template>

<script>
import { BCardBody, BAspect, BCard, BRow, BCol, BCardText, BButton } from 'bootstrap-vue'

export default {
  props: {
    news: {
      type: Array,
    },
  },

  components: {
    BAspect,
    BCard,
    BRow,
    BCol,
    BCardText,
    BButton,
    BCardBody
  },

  filters: {
    truncate: function(value, length, start = 0) {
      if (!value) return ''
      value = value.toString()
      if (value.length > length) {
        if (start > 0) {
          return value.substring(start, length + start) + '...'
        } else {
          return value.substring(start, length) + '...'
        }
      } else {
        return value
      }
    },
  },
}
</script>

<style scoped>
.card-img, .card-img-top, .card-img-bottom {
  object-fit: cover;
  object-position: center;
  aspect-ratio: 16/9;
}
</style>